import config from "../config";
import * as restApi from "./restApi";
import * as graphApi from "./graphApi";

let api = config.apiType === 'rest' ? restApi : graphApi;
export default api;
